import { z } from 'zod';
import { ToolCallView } from './capabilities.js';
import { ExecutionDetail } from './executions.js';
import { LlmCallView } from './llm.js';

/** Execution + everything it did (tool calls, LLM calls, cost) — the trace (06 §6–7). */
export const ExecutionTrace = ExecutionDetail.extend({
  toolCalls: z.array(ToolCallView),
  llmCalls: z.array(LlmCallView),
  totals: z.object({
    costUsd: z.number(),
    inputTokens: z.number().int(),
    outputTokens: z.number().int(),
    llmCalls: z.number().int(),
    toolCalls: z.number().int(),
  }),
});
export type ExecutionTrace = z.infer<typeof ExecutionTrace>;
